import React from 'react'
import EmailForm from '../form'
import Typical from 'react-typical'
import Experience from '../components/Experience'

const mockContent = (id) => {
  if (id === 1) {
    return (
      <div style={styles.profile}>
        <h2 style={styles.header}>Profile</h2>
        <p style={styles.statement}>
          I am a full stack software engineer with experience working on back-end systems and websites.
        </p>
        <hr />
        <h3 style={styles.subHeader}>About Me</h3>
        <p style={styles.paragraph}>
          Computers have been a part of my life from a very early age. So maybe it's not a big suprise that I ended up writing software for a living.
          My first ever memory of a computer was watching my brother and cousin playing video games such as Mortal Kombat, Cannon Fodder
          and Superfrog on the Commodore Amiga.
        </p>
        <p style={styles.paragraph}>
          Since then computers have come along way from what they were in the early 90s. The internet and the web has also changed a great deal.
          I still remember the early days of the world wide web when home internet was available through a 56k modem, in the days before broadband and
          high speed internet connections.
        </p>
        <p style={styles.paragraph}>
          I was in my early teens and I could only use the internet in our household for a short amount of time per day because the way home internet was
          priced was similar to paying for telephone calls.
          That is you get charged for how long your dialed in. Then when I finally dialed in, web pages took ages to load because the speed was usually
          less than 56kb a second. How crazy does it seem that now we have home internet that enables us to download gigabytes of data in less than a minute.
        </p>

        <p style={styles.paragraph}>
          <b>See below for more details about all my work experience and skills that I have as a software engineer.</b>
        </p>
      </div>
    )
  }

  if (id === 2) {
    return (
      <Experience styles={styles} />
    )
  }

  if (id === 3) {
    return (
      <div style={styles.profile}>
        <h2 style={styles.header}>Skills</h2>
        <p style={styles.statement}>
          <Typical
            steps={
              ['"Always code as if the guy who ends up maintaining your code will be a violent psychopath who knows where you live."', 50,
                '"Any fool can write code that a computer can understand. Good programmers write code that humans can understand!"', 50,
                '"while(!(succed == try()));"', 2000,
                '"Everybody in this country should learn how to program a computer, because it teaches you how to think."', 50]}
            loop={Infinity}
            wrapper='p'
          />
        </p>
        <hr />
        <h3 style={styles.subHeader}>Technologies</h3>
        <div style={styles.flexContainer}>
          <div style={styles.flexItem}>
            <h1>C#</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>.Net Framework</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>.Net Core</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>SQL</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>SQL Server</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Dapper</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Design Patterns</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>IoC/DI</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Web API</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>REST</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>MVC</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Web Forms</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>javaScript</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>ReactJS</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>HTML</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>CSS</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Python</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Azure</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>CI/CD</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>GCP</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Docker</h1>
          </div>
          <div style={styles.flexItem}>
            <h1>Kubernetes</h1>
          </div>
        </div>
        <hr />
        <h3 style={styles.subHeader}>Languages</h3>
        <ul style={styles.listItem}>
          <li>English - Native</li>
          <li>Spanish - Advanced</li>
        </ul>
      </div>
    )
  }

  if (id === 4) {
    return (
      <div style={styles.experience}>
        <h2 style={styles.header}>Projects</h2>
        <hr />
        <ul style={styles.listItem}>
          <li>Nandoca Identity</li>
          <li>Workday migration</li>
          <li>BeSmart budget setting tool for Unilever</li>
          <li>Training Scheme Administration website for civil engineers</li>
          <li>Institute of Civil Engineers bookshop website</li>
          <li>Thrombo Coach app for Bayer</li>
          <li>Bespoke CRM for Royal Horticultural Society</li>
          <li>Detention and Demurrage Calculator for Tesco freight shipping</li>
        </ul>
      </div>
    )
  }

  if (id === 5) {
    return (
      <div style={styles.profile}>
        <h2 style={styles.header}>Contact Me</h2>
        <EmailForm />
      </div>
    )
  }
}

const styles = {
  profile: {
    padding: '40px 120px 150px 120px',
    minWidth: '360px'
  },
  header: {
    fontSize: '52px',
    textAlign: 'center',
    fontWeight: '300'
  },
  statement: {
    textAlign: 'center',
    fontSize: '15px',
    color: 'rgb(101, 157, 189)',
    fontWeight: 'bold'
  },
  statementExperience: {
    fontSize: '15px',
    fontWeight: 'bold'
  },
  subHeader: {
    fontSize: '28px',
    fontWeight: '150'
  },
  experience: {
    backgroundColor: '#FBEEC1',
    padding: '40px 120px 450px 120px',
    minWidth: '360px'
  },
  pageFlexItemHeader: {
    fontSize: '40px'
  },
  paragraph: {
    lineHeight: '20px',
    padding: '5px'
  },
  listItem: {
    paddingLeft: '0px',
    listStyle: 'none',
    lineHeight: '40px'
  },
  titleDataContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  titleDataContainerItem: {
    fontWeight: 'bold'
  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  flexItem: {
    width: '200px',
    margin: '10px',
    textAlign: 'center',
    height: '80px',
    border: '1px black solid',
    backgroundColor: '#DAAD86',
    padding: '5px'
  }
}

export default mockContent
